import { apiClient } from './client';

export type VisualFormat = 'square' | 'portrait' | 'landscape' | 'og' | 'form-header';
export type Motion = 'build' | 'push' | 'build-push';

export interface VisualKitCatalog {
  frames: Array<{
    id: string;
    label: string;
    layout: 'ad' | 'cover' | 'background';
    formats: VisualFormat[];
    defaultFormat: VisualFormat;
    defaultBackground: string;
    tone?: 'dark' | 'light';
    speaker?: 'required' | 'optional';
  }>;
  formats: Array<{ id: VisualFormat; width: number; height: number }>;
  backgrounds: Array<{
    id: string;
    label: string;
    tone: 'dark' | 'light';
    formats: VisualFormat[];
    onlyFrames: string[] | null;
  }>;
  motions: Array<{ id: Motion; label: string }>;
  animation: { minSeconds: number; maxSeconds: number; defaultSeconds: number; formats: VisualFormat[] };
}

export interface VisualRequest {
  frame: string;
  format: VisualFormat;
  background: string;
  content: {
    eyebrow?: string;
    headline?: string;
    supporting?: string;
    date?: string[];
    label?: string;
    speaker?: { name: string; role?: string; photoBase64: string; photoMimeType: string };
  };
}

export const visualKitApi = {
  catalog: () => apiClient.get<VisualKitCatalog>('/visual-kit/catalog'),

  /** A PNG. Rule problems come back as an Error whose message lists each one on its own line. */
  render: (body: VisualRequest) =>
    apiClient.download('/visual-kit/render', {
      method: 'POST',
      body: JSON.stringify(body),
      headers: { 'Content-Type': 'application/json' },
    }),

  /** An MP4. Takes a few seconds per second of video. */
  animate: (body: VisualRequest & { motion: Motion; seconds: number }) =>
    apiClient.download('/visual-kit/animate', {
      method: 'POST',
      body: JSON.stringify(body),
      headers: { 'Content-Type': 'application/json' },
    }),
};
